export default "__VITE_ASSET__$8wwO603__"